import {match} from 'ts-pattern';

import {catchUnhandledDataGridActions} from '@dms/shared';

import {
  openBulkOperationActionDialog,
  type BulkOperationActionCallback,
  type BulkOperationActionCallbackParams,
} from 'features/eag-grid';

import {InterestDeleteBulkForm} from '../pages/InterestOverview/components/InterestDeleteBulkForm/InterestDeleteBulkForm';
import {InterestReassignBulkForm} from '../pages/InterestOverview/components/InterestReassignBulkForm/InterestReassignBulkForm';

export const interestBulkOperationActionCallback: BulkOperationActionCallback = (action) =>
  match({actionKey: action.actionKey, resourceId: action.resourceId})
    .with({actionKey: 'REASSIGN'}, () =>
      openBulkOperationActionDialog(action, <InterestReassignBulkForm action={action} />)
    )
    .with({actionKey: 'DELETE', resourceId: 'INTEREST'}, () => {
      const deleteAction: BulkOperationActionCallbackParams = {
        ...action,
        actionDefinition: {...action.actionDefinition, variant: 'danger'},
      };
      return openBulkOperationActionDialog(
        deleteAction,
        <InterestDeleteBulkForm action={deleteAction} />
      );
    })
    .otherwise(() => {
      catchUnhandledDataGridActions(action.actionKey);
    });
